import React from 'react';

import PropTypes from 'prop-types';

import ActivityFilter from '../ActivityFilter';
import ActivityList from '../ActivityList';

import { StyledActivityContainer } from './index.styled';

const ActivityContainer = ({
	activities,
	selectedActivity,
	setSelectedActivity,
	updateActivity,
	isVersionPC,
	filters,
	setFilters,
	updateSearch,
	currentTabMob,
}) => {
	localStorage.removeItem('currentDateCalendar');
	const updateResources = (newResources) => {
		setFilters({
			...filters,
			resources: newResources,
		});
	};

	const updateTreatments = (newTreatments) => {
		setFilters({
			...filters,
			treatments: newTreatments,
		});
	};

	if (!isVersionPC()) {
		if (
			currentTabMob === 'activities' &&
			(!activities || activities?.length === 0)
		) {
			setSelectedActivity(null, false);
		}
	}

	return (
		<>
			<StyledActivityContainer>
				{isVersionPC() && (
					<ActivityFilter
						filters={filters}
						updateSearch={updateSearch}
						updateResources={updateResources}
						updateTreatments={updateTreatments}
					/>
				)}
				<ActivityList
					activities={activities}
					filters={filters}
					setFilters={setFilters}
					selectedActivity={selectedActivity}
					setSelectedActivity={setSelectedActivity}
					updateActivity={updateActivity}
					isVersionPC={isVersionPC}
					updateSearch={updateSearch}
				/>
			</StyledActivityContainer>
		</>
	);
};

ActivityContainer.propTypes = {
	activities: PropTypes.arrayOf(PropTypes.object),
	selectedActivity: PropTypes.object,
	setSelectedActivity: PropTypes.func.isRequired,
	updateActivity: PropTypes.func.isRequired,
	isVersionPC: PropTypes.func,
	filters: PropTypes.object,
	setFilters: PropTypes.func,
	updateSearch: PropTypes.func,
	currentTabMob: PropTypes.string,
};
export default ActivityContainer;
